import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { StoreState } from './../../store';
import { DriversLicense } from './drivers-license.interface';
import { DriversLicenseService } from './drivers-license.service';

const service = new DriversLicenseService();

export interface DriversLicenseState {
   driversLicenses: Array<DriversLicense>;
}

const DriversLicenseStore: Module<DriversLicenseState, StoreState> = {
   namespaced: true,
   state: {
      driversLicenses: [],
   },
   getters: {
      driversLicenses: (state) => state.driversLicenses,
   },
   mutations: {
      SET_DRIVERS_LICENSES(state, driversLicenses: Array<DriversLicense>) {
         state.driversLicenses = driversLicenses;
      },
   },
   actions: {
      async getDriversLicenses(context, query: LocationQuery) {
         const driversLicenses = await service.getDriversLicenses({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_DRIVERS_LICENSES', driversLicenses.data);
         return driversLicenses;
      },
   },
};

export default DriversLicenseStore;
